(function () {
  if (window.__oulaiContactRoutingReady) {
    return;
  }

  window.__oulaiContactRoutingReady = true;

  var salesContacts = [
    { key: 'jasmine', name: 'Jasmine', email: 'jasmine@ntoulai.com', phone: '+86 18068169955', whatsapp: '8618068169955' },
    { key: 'catherine', name: 'Catherine', email: 'catherine@ntoulai.com', phone: '+86 15370488875', whatsapp: '8615370488875' },
    { key: 'zhang', name: 'Zhang', email: 'zhang@ntoulai.com', phone: '+86 18962863495', whatsapp: '8618962863495' }
  ];
  var explicitContactStorageKey = 'oulaiAssignedSalesKey';
  var legacyExplicitContactStorageKey = 'oulaiAssignedSalesIndex';
  var randomContactStorageKey = 'oulaiAssignedContactKey';
  var legacyRandomContactStorageKey = 'oulaiAssignedContactIndex';
  var contactsByKey = {};

  salesContacts.forEach(function (contact) {
    contactsByKey[contact.key] = contact;
  });

  function normalizeSalesValue(value) {
    return String(value || '').toLowerCase().replace(/^\s+|\s+$/g, '').replace(/[^a-z]/g, '');
  }

  function contactKeyFromValue(value) {
    var key = normalizeSalesValue(value);

    if (contactsByKey[key]) {
      return key;
    }

    return key === 'zh' ? 'zhang' : null;
  }

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      /* Storage can be unavailable in strict privacy modes. */
    }
  }

  function contactKeyFromLegacyIndex(value) {
    var index;

    if (value === null || !/^\d+$/.test(String(value))) {
      return null;
    }

    index = Number(value);

    return salesContacts[index] ? salesContacts[index].key : null;
  }

  function saveExplicitContact(key) {
    var contactKey = contactKeyFromValue(key);

    if (!contactKey) {
      return;
    }

    storageSet(window.sessionStorage, explicitContactStorageKey, contactKey);
    storageSet(window.localStorage, explicitContactStorageKey, contactKey);
    storageSet(window.sessionStorage, randomContactStorageKey, contactKey);
  }

  function readStoredContactKey(storageKey, legacyStorageKey, includeLocalStorage) {
    var savedKey = storageGet(window.sessionStorage, storageKey);
    var contactKey = contactKeyFromValue(savedKey);

    if (!contactKey && includeLocalStorage) {
      savedKey = storageGet(window.localStorage, storageKey);
      contactKey = contactKeyFromValue(savedKey);
    }

    if (contactKey) {
      return contactKey;
    }

    contactKey = contactKeyFromLegacyIndex(storageGet(window.sessionStorage, legacyStorageKey));

    if (!contactKey && includeLocalStorage) {
      contactKey = contactKeyFromLegacyIndex(storageGet(window.localStorage, legacyStorageKey));
    }

    if (contactKey) {
      storageSet(window.sessionStorage, storageKey, contactKey);

      if (includeLocalStorage) {
        storageSet(window.localStorage, storageKey, contactKey);
      }
    }

    return contactKey;
  }

  function readExplicitContactKey() {
    return readStoredContactKey(explicitContactStorageKey, legacyExplicitContactStorageKey, true);
  }

  function readSalesQueryValue() {
    var query = window.location.search ? window.location.search.slice(1).split('&') : [];

    for (var index = 0; index < query.length; index += 1) {
      var pair = query[index];
      var eqIndex = pair.indexOf('=');
      var rawName = eqIndex >= 0 ? pair.slice(0, eqIndex) : pair;
      var rawValue = eqIndex >= 0 ? pair.slice(eqIndex + 1) : '';
      var name = '';

      try {
        name = decodeURIComponent(rawName.replace(/\+/g, ' ')).toLowerCase();
      } catch (error) {
        name = rawName.toLowerCase();
      }

      if (name === 'sales') {
        try {
          return decodeURIComponent(rawValue.replace(/\+/g, ' '));
        } catch (error) {
          return rawValue;
        }
      }
    }

    return '';
  }

  function cleanedSearch() {
    var query = window.location.search ? window.location.search.slice(1).split('&') : [];
    var kept = [];

    query.forEach(function (pair) {
      var eqIndex = pair.indexOf('=');
      var rawName = eqIndex >= 0 ? pair.slice(0, eqIndex) : pair;
      var name = '';

      try {
        name = decodeURIComponent(rawName.replace(/\+/g, ' ')).toLowerCase();
      } catch (error) {
        name = rawName.toLowerCase();
      }

      if (name !== 'sales' && pair) {
        kept.push(pair);
      }
    });

    return kept.length ? '?' + kept.join('&') : '';
  }

  function shortPathMatch() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    var contactIndex = parts.length - 2;

    if (contactIndex < 0 || normalizeSalesValue(parts[contactIndex]) !== 'contact') {
      return null;
    }

    var salesKey = contactKeyFromValue(parts[contactIndex + 1]);

    if (salesKey === null) {
      return null;
    }

    return {
      key: salesKey,
      prefix: parts.slice(0, contactIndex)
    };
  }

  function redirectShortContactPath(match) {
    var prefix = match.prefix.length ? '/' + match.prefix.join('/') : '';
    var target = prefix + '/' + cleanedSearch() + window.location.hash;
    window.location.replace(target);
  }

  function applyIncomingAttribution() {
    var pathMatch = shortPathMatch();
    var queryKey;

    if (pathMatch) {
      saveExplicitContact(pathMatch.key);
      redirectShortContactPath(pathMatch);
      return true;
    }

    queryKey = contactKeyFromValue(readSalesQueryValue());

    if (queryKey !== null) {
      saveExplicitContact(queryKey);

      if (window.history && window.history.replaceState) {
        window.history.replaceState(
          window.history.state,
          document.title,
          window.location.pathname + cleanedSearch() + window.location.hash
        );
      }
    }

    return false;
  }

  if (applyIncomingAttribution()) {
    return;
  }

  function assignedContact() {
    var explicitKey = readExplicitContactKey();
    var savedKey;
    var rotationContact;

    if (explicitKey !== null) {
      return contactsByKey[explicitKey];
    }

    savedKey = readStoredContactKey(randomContactStorageKey, legacyRandomContactStorageKey, false);

    if (savedKey !== null) {
      return contactsByKey[savedKey];
    }

    var rotationIndex =
      (Math.floor(Date.now() / 60000) + Math.floor(Math.random() * salesContacts.length)) % salesContacts.length;
    rotationContact = salesContacts[rotationIndex];

    storageSet(window.sessionStorage, randomContactStorageKey, rotationContact.key);

    return rotationContact;
  }

  function contactLine(contact) {
    return contact.name + ' | ' + contact.email + ' | ' + contact.phone;
  }

  function applyAssignedContact(root) {
    var contact = assignedContact();
    var currentRoot = root || document;

    currentRoot.querySelectorAll('[data-oulai-contact-name]').forEach(function (item) {
      item.textContent = contact.name;
    });

    currentRoot.querySelectorAll('[data-oulai-contact-email]').forEach(function (item) {
      item.textContent = contact.email;
    });

    currentRoot.querySelectorAll('[data-oulai-contact-phone]').forEach(function (item) {
      item.textContent = contact.phone;
    });

    currentRoot.querySelectorAll('[data-oulai-assigned-sales-field]').forEach(function (field) {
      field.value = contactLine(contact);
    });

    currentRoot.querySelectorAll('[data-oulai-sales-key-field]').forEach(function (field) {
      field.value = contact.key;
    });

    currentRoot.querySelectorAll('[data-oulai-whatsapp-link]').forEach(function (link) {
      var text = link.getAttribute('data-oulai-message') || 'Hello Oulai Textile, I would like to discuss a home textile sourcing project.';
      link.href = 'https://wa.me/' + contact.whatsapp + '?text=' + encodeURIComponent(text + '\n\nPage: ' + window.location.href);
    });

    currentRoot.querySelectorAll('[data-oulai-email-link]').forEach(function (link) {
      var subject = link.getAttribute('data-oulai-subject') || 'Website sourcing inquiry';
      var body = link.getAttribute('data-oulai-message') || 'Hello Oulai Textile, I would like to discuss a home textile sourcing project.';
      link.href = 'mailto:' + contact.email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body + '\n\nPage: ' + window.location.href);
    });
  }

  window.__oulaiGetAssignedContact = assignedContact;
  window.__oulaiRefreshAssignedContacts = applyAssignedContact;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  onReady(function () {
    applyAssignedContact(document);
  });
})();
